import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=48fba4ea&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=js"
export * from "./todoList.vue?vue&type=script&lang=js"
import style0 from "./todoList.vue?vue&type=style&index=0&id=48fba4ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fba4ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fba4ea')) {
      api.createRecord('48fba4ea', component.options)
    } else {
      api.reload('48fba4ea', component.options)
    }
    module.hot.accept("./todoList.vue?vue&type=template&id=48fba4ea&scoped=true", function () {
      api.rerender('48fba4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product/todoList/todoList.vue"
export default component.exports